import { render, staticRenderFns } from "./StocktakingRuleInfo.vue?vue&type=template&id=6c457e09&scoped=true&"
import script from "./StocktakingRuleInfo.vue?vue&type=script&lang=js&"
export * from "./StocktakingRuleInfo.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingRuleInfo.vue?vue&type=style&index=0&id=6c457e09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c457e09",
  null
  
)

export default component.exports